import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { IonSpinner } from '@ionic/react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();
  const location = useLocation();

  // If auth is not initialized yet, show a loading spinner
  if (!isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <IonSpinner name="dots" />
      </div>
    );
  }

  // Only redirect if auth is initialized and user is not authenticated
  if (!isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: "/signin",
          state: { from: location },
        }}
      />
    );
  }

  return <>{children}</>;
};
